export default __webpack_public_path__ + "static/happy-driver-582eb639abcd261da9602bb7064dfb4b.png";